import styled from '@emotion/styled';

const StyledLabel = styled.label([
  ({ size, weight }) => `
  display: inline-block;
  font-size: ${labelSize[size || "m"]};
  font-weight: ${weight === "bold" ? "500" : "normal"};
  margin-bottom: 4px;
`,
  ({ required, requiredPosition }) => `
  ${required ? requiredPosition === "right" ? `
        :after {
          content: "*";
          color: #eb2101;
          display: inline-block;
          margin-left: 4px;
          font-size: 14px;
          line-height: 1;
        }` : `
        :before {
          content: "*";
          color: #eb2101;
          display: inline-block;
          margin-right: 4px;
          font-size: 14px;
          line-height: 1;
        }` : ""}`
]);
const Label = StyledLabel;
Label.defaultProps = {
  size: "m",
  weight: "normal",
  requiredPosition: "right"
};
const labelSize = {
  s: "12px",
  m: "15px",
  l: "18px"
};

export { Label };
